import { apiRequest } from '~/_v3/common/services/httpService';

export const getPayslipAgreementStatus = async () => {
	const authToken = localStorage.getItem('authToken');
	return apiRequest('/api/v1/user/payslip-agreement-status', 'GET', authToken);
};
